import React from 'react';

/**
 * Разбивает текст на части, оборачивая совпадения с query в <mark>.
 * Регистронезависимый поиск, без regex (чтобы избежать проблем с экранированием и lastIndex).
 *
 * @param {string} text — исходный текст
 * @param {string} query — строка поиска
 * @returns {Array<React.ReactNode>}
 */
export function highlightText(text, query) {
    if (!text || !query || !query.trim()) return [text];

    const trimmedQuery = query.trim();
    const lowerQuery = trimmedQuery.toLowerCase();
    const lowerText = text.toLowerCase();
    const result = [];
    let pos = 0;

    while (pos < text.length) {
        const matchIndex = lowerText.indexOf(lowerQuery, pos);
        if (matchIndex === -1) {
            result.push(text.slice(pos));
            break;
        }
        if (matchIndex > pos) {
            result.push(text.slice(pos, matchIndex));
        }
        result.push(
            React.createElement('mark', { key: 'hl-' + result.length }, text.slice(matchIndex, matchIndex + trimmedQuery.length))
        );
        pos = matchIndex + trimmedQuery.length;
    }

    return result;
}